/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Outdent = [
  "svg",
  defaultAttributes,
  [
    ["polyline", { points: "7 8 3 12 7 16" }],
    ["line", { x1: "21", x2: "11", y1: "12", y2: "12" }],
    ["line", { x1: "21", x2: "11", y1: "6", y2: "6" }],
    ["line", { x1: "21", x2: "11", y1: "18", y2: "18" }]
  ]
];

export { Outdent as default };
//# sourceMappingURL=outdent.js.map
